import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { blue } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import React from 'react';

const UserAgreementDialog = ({ title, buttonLabel, children, confirm }) => {
  const actions = [
    <Button key="button" color="primary" onClick={confirm}>
      {buttonLabel}
    </Button>,
  ];

  return (
    <Dialog open={true} titleStyle={{ color: 'white', backgroundColor: blue[500] }}>
      <DialogTitle>
        {
          <div>
            <div style={{ lineHeight: '24px' }}>{title}</div>
          </div>
        }
      </DialogTitle>
      <DialogContent dividers>
        <div>{children}</div>
      </DialogContent>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
};

UserAgreementDialog.defaultProps = {
  title: 'User Notice',
  buttonLabel: 'Confirm',
};
export default UserAgreementDialog;
